// extracted by mini-css-extract-plugin
module.exports = {"SYoutubeContainer":"Youtube_SYoutubeContainer__P0YT7","SConsentPlaceholder":"Youtube_SConsentPlaceholder__qC2CS"};